// @ts-nocheck
import { getCookie, removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getWishList } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import updateGetWishListsParameter from "@insite/client-framework/Store/Components/AddToListModal/Handlers/UpdateGetWishListsParameter";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
// import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList"; // Store Custom Code
import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import ScheduleReminderModal, {
    ScheduleReminderModalStyles,
} from "@insite/content-library/Components/ScheduleReminderModal";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
// import React, { useContext, useEffect, useState } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import VisuallyHidden from "@insite/mobius/VisuallyHidden/VisuallyHidden";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import { formGridProps } from "@store/Themes/common/props/form";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { useCurrentCartState } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
import React, { useContext, useEffect, useRef, useState } from "react";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import addToWishList from "@store/Framework/Store/Store/Data/WishLists/Handlers/AddToWishListWithKit";
import { KitProductInfo } from "@store/Framework/Types/KitProductInfo";
/* Store Custom Code - End */

interface OwnProps {
    extendedStyles?: AddToListModalStyles;
    // Starter Custom Code
    overridedStyles?: AddToListModalStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => {
    /* Starter Custom Code - Start */
    const productInfos = state.components.addToListModal.productInfos;
    const productId = productInfos && productInfos[0].productId;
    const product = getProductState(state, productId).value;
    /* Starter Custom Code - End */

    const settings = getSettingsCollection(state);
    return {
        session: state.context.session,
        modalIsOpen: state.components.addToListModal.isOpen,
        productInfos, // Starter Custom Code
        getWishListsParameter: state.components.addToListModal.getWishListsParameter,
        wishListsDataView: getWishListsDataView(state, state.components.addToListModal.getWishListsParameter),
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        location: getLocation(state),
        wishListSettings: settings.wishListSettings,
        // Starter Custom Code
        product,
    };
};

const mapDispatchToProps = {
    setAddToListModalIsOpen,
    addToWishList,
    updateGetWishListsParameter,
    loadWishLists,
    loadWishList,
};

export interface AddToListModalStyles {
    modal?: ModalPresentationProps;
    innerWrapper?: InjectableCss;
    signInMessageText?: TypographyProps;
    descriptionText?: TypographyProps;
    listsSelect?: DynamicDropdownPresentationProps;
    newListInput?: TextFieldProps;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    addButton?: ButtonPresentationProps;
    scheduleReminderCheckbox?: CheckboxPresentationProps;
    scheduleReminderModal?: ScheduleReminderModalStyles;
    // Starter Custom Code
    formGridContainer?: GridContainerProps;
    formGridItem?: GridItemProps;
}

export const addToListModalStyles: AddToListModalStyles = {
    modal: {
        sizeVariant: "small",
    },
    descriptionText: {
        variant: "p",
    },
    cancelButton: {
        variant: "secondary",
    },
    formGridContainer: formGridProps.gridContainer,
    formGridItem: { width: 12 },
    scheduleReminderCheckbox: {
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css}
            align-items: flex-start;
        `,
    },
};

export const LastUpdatedListIdCookieName = "LastUpdatedListId";

const AddToListModal = ({
    productInfos,
    session,
    modalIsOpen,
    getWishListsParameter,
    wishListsDataView,
    signInUrl,
    location,
    wishListSettings,
    setAddToListModalIsOpen,
    addToWishList,
    updateGetWishListsParameter,
    loadWishLists,
    loadWishList,
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
    product,
}: Props) => {
    /* Starter Custom Code - Start */
    const styles = useExpandProps(addToListModalStyles, extendedStyles, overridedStyles);
    const { value: cart } = useCurrentCartState();
    const items = productInfos?.map(product => {
        return cart?.cartLines?.find(x => x.productId === product.productId);
    });
    const trackCreateWishList = ga.use.trackCreateWishList();
    const trackAddToWishList = ga.use.trackAddToWishList();
    const listNameFieldRef = useRef<HTMLInputElement>(null);
    /* Starter Custom Code - End */

    const toasterContext = useContext(ToasterContext);

    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const [selectedWishListId, setSelectedWishListId] = useState("new");
    const [newListName, setNewListName] = useState("");
    const [selectListError, setSelectListError] = useState<React.ReactNode>("");
    const [newListNameError, setNewListNameError] = useState<React.ReactNode>("");
    const [options, setOptions] = useState<OptionObject[]>([]);
    const [inProgress, setInProgress] = useState(false);
    const [isScheduled, setIsScheduled] = useState(false);
    const [scheduleReminderModalIsOpen, setScheduleReminderModalIsOpen] = useState(false);
    const [currentWishList, setCurrentWishList] = useState<WishListModel>();

    useEffect(() => {
        if (!modalIsOpen) {
            return;
        }

        const lastUpdatedListId = getCookie(LastUpdatedListIdCookieName) || "new";
        setSelectedWishListId(lastUpdatedListId);
        if (
            isAuthenticated &&
            lastUpdatedListId !== "new" &&
            (!wishListsDataView.value || !wishListsDataView.value.find(o => o.id === lastUpdatedListId)) &&
            (!currentWishList || currentWishList.id !== lastUpdatedListId)
        ) {
            loadWishList({
                wishListId: lastUpdatedListId,
                onComplete: ({ apiResult }) => {
                    setCurrentWishList(apiResult);

                    if (!apiResult) {
                        setSelectedWishListId("new");
                        removeCookie(LastUpdatedListIdCookieName);
                    }
                },
            });
        }
    }, [modalIsOpen]);

    useEffect(() => {
        if (modalIsOpen && !wishListsDataView.value && !wishListsDataView.isLoading) {
            loadWishLists(getWishListsParameter);
        }
    }, [getWishListsParameter]);

    useEffect(() => {
        let options: OptionObject[] = [{ optionText: translate("Create New List"), optionValue: "new" }];
        if (wishListsDataView.value) {
            options = options.concat(
                wishListsDataView.value
                    .filter(o => !o.isAutogenerated)
                    .map(o => ({ optionText: o.name, optionValue: o.id })),
            );
        }
        if (currentWishList && !options.find(o => o.optionValue === currentWishList.id)) {
            options.push({ optionText: currentWishList.name, optionValue: currentWishList.id });
        }
        setOptions(options);
    }, [wishListsDataView, currentWishList]);

    if (!productInfos) {
        return null;
    }

    const modalCloseHandler = () => {
        setNewListName("");
        setSelectListError("");
        setNewListNameError("");
        setInProgress(false);
        setAddToListModalIsOpen({ modalIsOpen: false });
    };

    const listChangeHandler = (value?: string) => {
        setCurrentWishList(wishListsDataView.value?.find(o => o.id === value));
        setSelectedWishListId(value || "new");
        setSelectListError("");
    };

    const debouncedUpdateParameter = debounce((value: string) => {
        updateGetWishListsParameter({
            ...getWishListsParameter,
            query: value || undefined,
        });
    }, 200);

    const listsInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        debouncedUpdateParameter(event.currentTarget.value);
    };

    const onClosingDropdownHandler = () => {
        if (selectedWishListId !== currentWishList?.id) {
            setCurrentWishList(undefined);
        }
    };

    const newListInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewListName(event.target.value);
        let error = "";
        if (!event.target.value) {
            error = siteMessage("Lists_Enter_New_Wishlist_Name") as string;
        } else if (event.target.value.length > 100) {
            error = siteMessage("Lists_List_Name_Too_Long", "100") as string;
        }
        setNewListNameError(error);
    };

    const scheduleReminderChangeHandler = (_: React.SyntheticEvent<Element, Event>, value: boolean) => {
        setIsScheduled(!isScheduled);
    };

    const closeScheduleReminderModalHandler = () => {
        setScheduleReminderModalIsOpen(false);
        setIsScheduled(false);
        modalCloseHandler();
    };

    const addToListButtonClickHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        const isNewList = selectedWishListId === "new";

        if (!currentWishList && !isNewList) {
            setSelectListError(siteMessage("Lists_Enter_New_Wishlist_Name"));
            return;
        }

        if (isNewList && !newListName) {
            setNewListNameError(siteMessage("Lists_Enter_New_Wishlist_Name"));
            listNameFieldRef.current?.focus(); // Starter Custom Code
            return;
        }

        if (isNewList && newListName && newListName.length > 100) {
            setNewListNameError(siteMessage("Lists_List_Name_Too_Long", "100"));
            return;
        }

        setNewListNameError("");
        setSelectListError("");

        setInProgress(true);

        /* Store Custom Code - Start */
        const productInfosWithQtyOne: KitProductInfo[] = (productInfos as KitProductInfo[]).map(p => ({
            ...p,
            qtyOrdered: 1,
        }));
        /* Store Custom Code - End */

        addToWishList({
            productInfos: productInfosWithQtyOne, // Store Custom Code
            selectedWishList: isNewList ? undefined : currentWishList,
            newListName,
            onSuccess: async (wishList: WishListModel) => {
                setCookie(LastUpdatedListIdCookieName, wishList.id);
                setSelectedWishListId(wishList.id);
                setCurrentWishList(wishList);
                /* Starter Custom Code - Start */
                trackAddToWishList(
                    { items: product || items, item_list_id: wishList.id },
                    { productInfos: productInfosWithQtyOne as ProductInfo[] }, // Store Custom Code
                );
                if (isNewList) {
                    trackCreateWishList({}, { wishList });
                }
                /* Starter Custom Code - End */
                toasterContext.addToast({
                    body: siteMessage("Lists_ProductAdded"),
                    messageType: "success",
                    // Starter Removed - isFocusAfterMount
                });
                if (isScheduled) {
                    const updatedWishList = await getWishList({ wishListId: wishList.id, expand: ["schedule"] });
                    setCurrentWishList(updatedWishList);
                    setScheduleReminderModalIsOpen(true);
                } else {
                    modalCloseHandler();
                }
            },
            onError: errorMessage => {
                setInProgress(false);

                if (isNewList) {
                    setNewListNameError(errorMessage);
                } else {
                    modalCloseHandler();
                    toasterContext.addToast({ body: errorMessage, messageType: "danger" });
                }
            },
            onComplete(wishListProps) {
                if (wishListProps?.result?.wishList) {
                    // "this" is targeting the object being created, not the parent SFC

                    this.onSuccess?.(wishListProps?.result?.wishList);
                } else if (wishListProps?.result?.errorMessage) {
                    // "this" is targeting the object being created, not the parent SFC
                    this.onError?.(wishListProps?.result?.errorMessage);
                }
            },
        });
    };

    const returnUrl = location.pathname + location.search;

    return (
        <Modal
            {...styles.modal}
            headline={isAuthenticated ? translate("Add to List") : translate("Please Sign In")}
            isOpen={modalIsOpen}
            handleClose={modalCloseHandler}
            alert={!isAuthenticated} // Starter Custom Code
        >
            <StyledWrapper {...styles.innerWrapper} data-test-selector="productAddToListModal">
                {!isAuthenticated && (
                    <Typography data-test-selector="productAddToListModal_requireSignIn" {...styles.signInMessageText}>
                        {siteMessage(
                            "Lists_Must_Sign_In_Spire",
                            `${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`,
                        )}
                    </Typography>
                )}
                {isAuthenticated && (
                    <>
                        <Typography {...styles.descriptionText}>
                            {translate("Add items to a new or existing list.")}
                        </Typography>
                        <GridContainer {...styles.formGridContainer /* Starter Custom Code */}>
                            <GridItem {...styles.formGridItem /* Starter Custom Code */}>
                                <DynamicDropdown
                                    label={translate("Select List")}
                                    {...styles.listsSelect}
                                    isLoading={wishListsDataView.isLoading}
                                    onInputChange={listsInputChangeHandler}
                                    onSelectionChange={listChangeHandler}
                                    onClose={onClosingDropdownHandler}
                                    selected={selectedWishListId}
                                    options={options}
                                    error={selectListError}
                                    data-test-selector="productAddToListModal_listSelect"
                                />
                            </GridItem>
                            {selectedWishListId === "new" && (
                                <GridItem {...styles.formGridItem /* Starter Custom Code */}>
                                    <TextField
                                        label={translate("New List Name")}
                                        value={newListName}
                                        error={newListNameError}
                                        onChange={newListInputChangeHandler}
                                        {...styles.newListInput}
                                        data-test-selector="productAddToListModal_newName"
                                        // Starter Custom Code
                                        required
                                        ref={listNameFieldRef}
                                    />
                                    {/* Starter Custom Code - Start */}
                                    {newListNameError ? (
                                        <VisuallyHidden role="alert">{newListNameError}</VisuallyHidden>
                                    ) : null}
                                    {/* Starter Custom Code - End */}
                                </GridItem>
                            )}
                            {wishListSettings.enableWishListReminders && (
                                <GridItem {...styles.formGridItem /* Starter Custom Code */}>
                                    <Checkbox
                                        {...styles.scheduleReminderCheckbox}
                                        checked={isScheduled}
                                        onChange={scheduleReminderChangeHandler}
                                    >
                                        {siteMessage("Lists_Schedule_Reminders")}
                                    </Checkbox>
                                </GridItem>
                            )}
                        </GridContainer>
                        {/* Starter Custom Code - Start */}
                        <FormActions>
                            <Button
                                {...styles.addButton}
                                onClick={e => addToListButtonClickHandler(e)}
                                data-test-selector="productAddToListModal_addButton"
                                disabled={inProgress}
                            >
                                {translate("Add to List")}
                            </Button>
                            <Button {...styles.cancelButton} onClick={modalCloseHandler}>
                                {translate("Cancel")}
                            </Button>
                        </FormActions>
                        {/* Starter Custom Code - End */}
                        {isScheduled && currentWishList && (
                            <ScheduleReminderModal
                                wishList={currentWishList}
                                isOpen={scheduleReminderModalIsOpen}
                                handleClose={closeScheduleReminderModalHandler}
                                extendedStyles={styles.scheduleReminderModal}
                            />
                        )}
                    </>
                )}
            </StyledWrapper>
        </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToListModal);
